import { apiClient } from './apiClient';

export const productService = {
  // Get all products with optional filters
  async getProducts(filters = {}) {
    const params = new URLSearchParams();
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value);
      }
    });

    const queryString = params.toString();
    const endpoint = queryString ? `/products?${queryString}` : '/products';
    
    return apiClient.get(endpoint);
  },

  // Get single product by ID
  async getProductById(id) {
    return apiClient.get(`/products/${id}`);
  },

  // Get related products
  async getRelatedProducts(id, limit = 4) {
    return apiClient.get(`/products/${id}/related?limit=${limit}`);
  },

  // Create new product (admin only)
  async createProduct(productData) {
    return apiClient.post('/admin/products', productData);
  },

  // Update product (admin only)
  async updateProduct(id, productData) {
    return apiClient.put(`/admin/products/${id}`, productData);
  },

  // Delete product (admin only)
  async deleteProduct(id) {
    return apiClient.delete(`/admin/products/${id}`);
  },

  // Toggle product featured status (admin only)
  async toggleFeatured(id) {
    return apiClient.patch(`/admin/products/${id}/featured`);
  },

  // Toggle product best seller status (admin only)
  async toggleBestSeller(id) {
    return apiClient.patch(`/admin/products/${id}/best-seller`);
  },

  // Update product stock (admin only)
  async updateStock(id, stockData) {
    return apiClient.patch(`/admin/products/${id}/stock`, stockData);
  }
};
